import React, { useState } from "react"
import { useCurrentUser } from "hooks/use-current-user"

export function PayWhatYouWantInput({ price, textColor }) {
  const user = useCurrentUser()
  const [chosenAmount, setChosenAmount] = useState(
    price.suggested_amount_as_string || ""
  )
  return (
    <>
      <label
        className="formkit-pwyw-input___label"
        htmlFor="payWhatYouWantPriceInput"
        style={{ color: textColor }}
      >
        Choose how much to pay
      </label>
      <div className="flex-row w-full relative">
        <input
          id="payWhatYouWantPriceInput"
          className="formkit-input formkit-pwyw-input"
          name="pay_what_you_want_price"
          required={true}
          value={chosenAmount}
          onChange={e => setChosenAmount(e.target.value)}
          type="number"
          placeholder={`Enter ${price.formatted} or more`}
        />
        <div className="bg-gray-100 flex formkit-pwyw-input___currency">
          {
            user.commerce.available_currencies.find(
              cur => cur.iso_code == price.currency
            ).display_name
          }
        </div>
      </div>
    </>
  )
}
